import { Box, Button, Flexbox, Label } from "codekit";
import { useEffect, useRef } from "react";
import useVersionCheck from "../../hooks/useVersionCheck";

const HIDDEN_RELOAD_MS = 30 * 60 * 1000;

/**
 * Banner de nueva version: avisa cuando hay un despliegue nuevo del front y
 * recarga automaticamente cuando es seguro hacerlo (la pestaña estuvo oculta
 * 30+ minutos, sin usuario interactuando con formularios)
 */
const Newverxx = () => {
  const isUpdateAvailable = useVersionCheck();
  const hiddenAtRef = useRef(null);

  //Funcion para recargar limpiando los caches del navegador (Cache Storage y Service Workers)
  const handleUpdate = async () => {
    try {
      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
      }
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
    } catch {
      //La limpieza de cache no debe impedir la recarga
    }
    //Query de un solo uso que fuerza al navegador a pedir el index.html fresco
    window.location.replace(window.location.pathname + "?nv=" + Date.now());
  };

  //Limpia el query nv despues de la recarga forzada
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("nv")) {
      url.searchParams.delete("nv");
      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }, []);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        hiddenAtRef.current = Date.now();
        return;
      }
      const hiddenTime = hiddenAtRef.current ? Date.now() - hiddenAtRef.current : 0;
      if (isUpdateAvailable && hiddenTime >= HIDDEN_RELOAD_MS) {
        handleUpdate();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
    // eslint-disable-next-line
  }, [isUpdateAvailable]);

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <Box
      style={{ position: "fixed", bottom: "16px", right: "16px", zIndex: 9999 }}
      bg="warning-500"
      spacing={4}
      rounded="md"
      shadow
    >
      <Flexbox alignItems="center" gap={4}>
        <Label color="white">Hay una nueva versión de CIMA disponible</Label>
        <Button variant="secondary" size="m" type="button" onClick={() => handleUpdate()}>
          Actualizar
        </Button>
      </Flexbox>
    </Box>
  );
};

export default Newverxx;
